import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-settlements-template',
  templateUrl: './settlements-template.component.html',
  styleUrls: ['./settlements-template.component.scss']
})
export class SettlementsTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
